import { Heading } from 'components';
import PropTypes from 'prop-types';
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { HiPlus } from 'react-icons/hi';
import { RiCloseLine } from 'react-icons/ri';

function StepHeading({
  children,
  as,
  stepNumber,
  isComplete,
  onClick,
  size,
  color,
  isUpperCase,
  hasError,
  isOpen
}) {
  const variantStyling = {
    size: '',
    color: ''
  };

  switch (color) {
    case 'gray':
      variantStyling.color = 'bg-pink-swan';
      break;
    case 'green':
      variantStyling.color = 'bg-green';
      break;
    case 'black':
      variantStyling.color = 'bg-black';
      break;
    default:
      variantStyling.color = 'bg-green';
  }

  switch (size) {
    case 'sm':
      variantStyling.size = 'w-6 h-6';
      break;
    case 'md':
      variantStyling.size = 'w-8 h-8';
      break;
    case 'lg':
      variantStyling.size = 'w-10 h-10';
      break;
    default:
      variantStyling.size = 'w-6 h-6';
  }

  const limitString = children.substring(0, 30);

  if (hasError) variantStyling.color = 'bg-cinnebar';
  if (isComplete) variantStyling.color = 'bg-green';

  const handleStepDisplay = () => {
    if (isComplete) {
      return <FaCheck className="fill-white" />;
    }
    if (hasError) {
      return <RiCloseLine className="fill-white" />;
    }
    return <span className="m-0 text-white">{stepNumber}</span>;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center border-none bg-transparent"
      id={stepNumber}
    >
      <div
        className={`mr-4 flex shrink-0 items-center justify-center rounded-full font-bold
          ${variantStyling.size}
          ${variantStyling.color}`}
      >
        {handleStepDisplay()}
      </div>
      <div className="flex w-full justify-between">
        {children && (
          <Heading as={as} isUpperCase={isUpperCase} noMargin={true}>
            {limitString}
          </Heading>
        )}
        {isOpen ? <RiCloseLine /> : <HiPlus />}
      </div>
    </button>
  );
}

StepHeading.propTypes = {
  children: PropTypes.string,
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']),
  stepNumber: PropTypes.number.isRequired,
  isComplete: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.oneOf(['green', 'gray', 'black']),
  isUpperCase: PropTypes.bool,
  hasError: PropTypes.bool,
  isOpen: PropTypes.bool
};

StepHeading.defaultProps = {
  children: 'Step Title',
  as: 'h4',
  isComplete: false,
  onClick: () => {},
  size: 'sm',
  color: 'green',
  isUpperCase: false,
  hasError: false,
  isOpen: false
};

export default StepHeading;
